<template>
  <div>

    <b-card title="Icon Yükle">
      <pre-loading v-if="uploading" />
      <template v-else>
        <!-- Eğer logo mevcutsa resmi görüntülemek için b-img kullanıyoruz -->
        <b-img
          v-if="itemData.image"
          :src="baseURL + '/media/dealers/' + itemData.image"
          alt="Icon"
          fluid
          class="mb-3"
        />
        <b-form-file
          id="image-file"
          v-model="image"
          class="mt-1"
          placeholder="Bir dosya seçin veya buraya bırakın..."
          drop-placeholder="Dosyayı buraya bırakın..."
          browse-text="Dosya Seçin"
        />
        <div class="mt-1">
          <b-button
            variant="primary"
            :disabled="!image"
            @click="uploadFile"
          >
            <FeatherIcon icon="UploadIcon" />
            Icon Yükle
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BImg,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'ImageCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BImg,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      image: null,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['dealers/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.image)

      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: this.image,
        folder: 'dealers',
      })
        .then(response => {
          this.itemData.image = response.filename
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
  },
}
</script>
